import React from 'react'
import { formatDate, formatNumber } from '../../../core/utils/common'
import { FlexCenter, Padding } from '../../../styles/CommonStyles'
import { ItemRow } from '../../../styles/newStyles/MobileModal.styled'
import { TransactionStatus, DetailText } from '../../../styles/TransactionHistoryStyles'
import { TextWithMargin } from '../../../styles/OrdersStyle'
import CoinImg from '../../common/CoinImg'
import Text from '../../../core/utils/Text'
import { useMainContext } from '../../../core/contexts/main'

const WalletHistoryDetailsModal = ({ data, onClose, type = 'wallet' }) => {
    const {
        main: { lang },
    } = useMainContext()

    return (
        <div>
            <FlexCenter width='100%'>
                <Padding padding='10px 0' style={{ borderBottom: '1px solid #ffffff15' }}>
                    <DetailText>
                        <Text tid='see-details' />
                    </DetailText>
                </Padding>
            </FlexCenter>

            <div className='p-2 bg-slate-100 dark:bg-transparent rounded-xl mb-4'>
                {type === 'wallet' && (
                    <ItemRow className='dark:border-b dark:border-card-border'>
                        <Text tid='coin' className='text-pcolor-light text-sm' />
                        <FlexCenter className='gap-2'>
                            <>
                                <CoinImg id={data.coin} className='w-5 h-5' />
                                <span>{data.coin?.toUpperCase()}</span>
                            </>
                        </FlexCenter>
                    </ItemRow>
                )}
                <ItemRow className='dark:border-b dark:border-card-border'>
                    <Text tid='type' className='text-pcolor-light text-sm' />
                    <TextWithMargin type={data.flow}>
                        <Text tid={data.flow} />
                    </TextWithMargin>
                </ItemRow>
                <ItemRow className='dark:border-b dark:border-card-border'>
                    <Text tid='amount' className='text-pcolor-light text-sm' />
                    <span>{data.amount ? formatNumber(data.amount) : '--'}</span>
                </ItemRow>

                <ItemRow className='dark:border-b dark:border-card-border'>
                    <Text tid='status' className='text-pcolor-light text-sm' />
                    <TransactionStatus status={data.status}>
                        <Text tid={`T${data.status}`} />
                    </TransactionStatus>
                </ItemRow>

                <ItemRow>
                    <Text tid='date' className='text-pcolor-light text-sm' />
                    <div className='flex flex-col gap-1'>
                        <span>{formatDate(data.createdAt, 'date', lang)}</span>
                        <span>{formatDate(data.createdAt, 'time', lang)}</span>
                    </div>
                </ItemRow>
            </div>
        </div>
    )
}

export default WalletHistoryDetailsModal
